import { fromJS } from "immutable";

export const STATE_WEBBOT = "webbot";
export const STATE_WEBBOT_PREVIEWS = "previews";
export const STATE_WEBBOT_MESSAGES = "messages";
export const STATE_WEBBOT_MESSAGE = "message";
export const STATE_WEBBOT_ALL_MESSAGES = "allMessages-";
export const STATE_WEBBOT_IS_TYPING = "isTyping";
export const STATE_WEBBOT_CONNECTING = "connecting";
export const STATE_WEBBOT_CONNECTION = "connection";
export const STATE_WEBBOT_CONNECTIONS = "connections";
export const STATE_WEBBOT_ERROR = "error";
export const STATE_WEBBOT_ACTIONS = "actions";
export const STATE_WEBBOT_STATUS = "status";
export const STATE_WEBBOT_FROM = "from";
export const STATE_WEBBOT_TYPE = "type";
export const STATE_WEBBOT_URLS = "urls";
export const STATE_WEBBOT_REQUEST_URL = "requestUrl";
export const STATE_WEBBOT_ID_MESSAGE_EVALUATE = "id_message_evaluate";
export const STATE_WEBBOT_SHOW_AVATAR = "showAvatar";
export const STATE_WEBBOT_OPTIONS_TYPE = "options_type";
export const STATE_WEBBOT_OPTIONS = "options";
export const STATE_WEBBOT_ARE_BUTTONS_VISIBLE = "areButtonsVisible";
export const STATE_WEBBOT_ID = "id";
export const STATE_WEBBOT_IS_RESTARTING_CHAT = "isRestartingChat";
export const STATE_WEBBOT_CVARS_SAVED = "cvars";
export const STATE_WEBBOT_SDK_TYPE = "sdk";
export const STATE_WEBBOT_SKIP_USER_INPUT = "skip_user_input";

export const STATE_WEBBOT_DEFAULT = fromJS({
  [STATE_WEBBOT_MESSAGES]: [],
  [STATE_WEBBOT_IS_TYPING]: false,
  [STATE_WEBBOT_CONNECTING]: false,
  [STATE_WEBBOT_CONNECTION]: false,
  [STATE_WEBBOT_ERROR]: null,
  [STATE_WEBBOT_PREVIEWS]: [],
  [STATE_WEBBOT_IS_RESTARTING_CHAT]: false,
  [STATE_WEBBOT_CVARS_SAVED]: "",
});
